"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const updatedDiff = (lhs, rhs) => {
    if (lhs === rhs)
        return {};
    if (!(0, utils_1.isObject)(lhs) || !(0, utils_1.isObject)(rhs))
        return rhs;
    if ((0, utils_1.isDate)(lhs) || (0, utils_1.isDate)(rhs)) {
        return (lhs.valueOf() !== rhs.valueOf()
            && lhs !== undefined
            && rhs !== undefined
            ? rhs
            : {});
    }
    if ((0, utils_1.isArray)(lhs) || (0, utils_1.isArray)(rhs)) {
        return (JSON.stringify(lhs) !== JSON.stringify(rhs)
            && lhs !== undefined
            && rhs !== undefined
            ? rhs
            : {});
    }
    return Object.keys(rhs).reduce((acc, key) => {
        if ((0, utils_1.hasOwnProperty)(lhs, key)) {
            const difference = updatedDiff(lhs[key], rhs[key]);
            if ((0, utils_1.isEmptyObject)(difference) && !(0, utils_1.isDate)(difference) && ((0, utils_1.isEmptyObject)(lhs[key]) || !(0, utils_1.isEmptyObject)(rhs[key]))) {
                return acc;
            }
            acc[key] = difference;
            return acc;
        }
        return acc;
    }, (0, utils_1.makeObjectWithoutPrototype)());
};
exports.default = updatedDiff;
